import { Component, Input } from '@angular/core'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms'
import * as lodash from 'lodash'
import { defaultSignerOrderValue } from '../../../template-drawer/components/signing-order-editor/signing-order-editor.component'
import { guestToSignerFormData, SignerOptionItem, userToSignerFormData } from '../signer-input-base.component'
import { Guest } from '@tv3/store/guest/guest.model'
import { ContractSignerType, ContractTemplate, SignatureRole, TemplateTypes } from '@tokeet-frontend/signature'
import { emailValidator, User } from '@tokeet-frontend/tv3-platform'

export interface SignerItemFormDataWithRole extends SignerOptionItem {
  save: boolean
}

export interface OneDefaultSigner {
  type: ContractSignerType
  data: Guest | User
}

export function createSignersForm(formBuilder: FormBuilder) {
  return formBuilder.array([])
}

export function setSignersWithRoleFormData(
  fb: FormBuilder,
  signersForm: FormArray,
  template: ContractTemplate,
  defaultSigner?: OneDefaultSigner
) {
  signersForm.clear()

  const isSignerCustomizable = template.type !== TemplateTypes.Form
  const settingsForRoles = template.signers

  const newSignerForm = (role: string) => {
    const settingsForRole = lodash.find(settingsForRoles, ({ role: r }) => r === role)
    const idPhotoRequired = settingsForRole ? settingsForRole.id_photo_required : template.id_photo_required
    const selfiePhotoRequired = settingsForRole?.selfie_photo_required || false

    const item = fb.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email, emailValidator]],
      type: [],
      role: [role, [Validators.required]],
      order: [settingsForRole?.order || defaultSignerOrderValue],
      id_photo_required: [idPhotoRequired],
      selfie_photo_required: [selfiePhotoRequired],
      save: [false],
      id: [],
      data: [],
    })

    if (defaultSigner) {
      // set default signer
      if (defaultSigner.type === ContractSignerType.Staff && SignatureRole.isUserRole(role)) {
        const user = defaultSigner.data as User
        item.patchValue({
          ...userToSignerFormData(user, role),
          data: user,
        })
      }

      if (defaultSigner.type === ContractSignerType.Guest && !SignatureRole.isUserRole(role)) {
        const guest = defaultSigner.data as Guest
        item.patchValue({
          ...guestToSignerFormData(guest, role),
          data: guest,
        })
      }
      defaultSigner = null // only set once
    }

    return item
  }

  lodash.forEach(template.roles, (role) => {
    const signerForm = newSignerForm(role)
    // always save this contact
    if (!isSignerCustomizable) {
      signerForm.get('save').setValue(true)
      signerForm.get('save').disable()
    }

    signersForm.push(signerForm)
  })
}

@Component({
  selector: 'app-signers-with-role',
  templateUrl: './signers-with-role.component.html',
  styleUrls: ['./signers-with-role.component.scss'],
})
export class SignersWithRoleComponent {
  @Input() form: FormArray
  @Input() isSignerCustomizable: boolean
  @Input() templateType: TemplateTypes

  templateTypes = TemplateTypes

  isUserRole = (r) => SignatureRole.isUserRole(r)
  isGuestRole = (r) => SignatureRole.isGuestRole(r)

  constructor() {}

  onSignerSelect(signerForm: FormGroup, signer: SignerOptionItem) {
    signerForm.patchValue({
      name: signer.name,
      email: signer.email,
      type: signer.type,
      id: signer.id,
      data: signer.data,
    })
  }
}
